let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("FAW7r")).then(() => parcelRequire('3UqVx'));